import { create } from 'zustand'


export const useChanceStore = create(set => ({
  billInfList: [],
  billInvList: [],
//   setBillInfList: (newList) => set({ billInfList: newList }),
//   setBillInvList: (newList) => set({ billInvList: newList }),
  
  setBillInfList: (list) => {
    // console.log('🔥 setBillInfList 호출:', list)
    set({ billInfList: list })
  },

  setBillInvList: (list) => {
    // console.log('🚀 setBillInvList 호출:', list)
    set({ billInvList: list })
  },

}))